import * as ProductType from '@upgrade/ui-utils/constants/product-types';
import { postJson } from './fetch-json';

export const postDepositLead = ({ email }) =>
  postJson({
    url: '/api/brfunnelorch/v1/leads',
    data: { leadType: 'DEPOSIT_DEFERRED_PASSWORD_LEAD', productType: ProductType.DEPOSIT, contactDetail: { email } }
  });

export const postPlcEmailLead = ({ email, programDefinitionCode }) =>
  postJson({
    url: '/api/pclapplication/v1/leads',
    data: {
      leadType: 'PCL_DEFERRED_PASSWORD_LEAD',
      productType: ProductType.PERSONAL_CREDIT_LINE,
      programDefinitionCode,
      contactDetail: { email }
    }
  });

export const postPlLead = ({ email }) =>
  postJson({
    url: '/api/plapplication/v1/leads',
    data: {
      leadType: 'PL_DEFERRED_PASSWORD_LEAD',
      productType: ProductType.PERSONAL_LOAN,
      programDefinitionCode: 'PL_DEFAULT',
      contactDetail: {
        email
      }
    }
  });
